import { RECIPE_FOODS } from './homeRecipes'
import { BRAND_DRINKS } from './brandDrinks'
import data from './foodCatalog.json'
import { foodSchema, type Food, type SavedFood } from './nutrition'

// Reviewed Chinese aliases of the CC0 USDA SR Legacy subset. No remote requests.
export const FOOD_CATALOG: readonly Food[] = data.map((food) => foodSchema.parse(food))
export const FOOD_CATALOG_COUNT = FOOD_CATALOG.length + RECIPE_FOODS.length + BRAND_DRINKS.length
export function searchFoodCatalog(query: string, saved: readonly SavedFood[] = []): Food[] {
  const terms = query.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean)
  const localTerms = new Map(saved.map(record => [record.id, record.searchTerms ?? []]))
  const names = (food: Food) => [food.name, ...(food.aliases ?? []), ...(localTerms.get(food.id) ?? [])]
  return [...saved.map(record => record.food), ...RECIPE_FOODS, ...BRAND_DRINKS, ...FOOD_CATALOG].filter((food, index, all) => all.findIndex(f => f.id === food.id) === index).filter((food) => {
    const text = `${names(food).join(' ')} ${food.category ?? ''}`.toLocaleLowerCase()
    return terms.every((term) => text.includes(term))
  }).sort((a, b) => {
    const exact = (f: Food) => Number(names(f).some((name) => name.toLocaleLowerCase() === query.trim().toLocaleLowerCase()))
    return exact(b) - exact(a)
  }).map((food) => structuredClone(food))
}
